import { ApiPermissions } from "../shared/services/volateq-api/api-permissions";
import { RouteOptions } from "../types";

const AppPublicApiDoc = () => import("@/app/doc/public-api-doc.vue");

const docRoutes: RouteOptions[] = [
  {
    name: "PublicApiDoc",
    path: "/doc/public-api",
    component: AppPublicApiDoc,
    meta: {
      permission: [ApiPermissions.MANAGE_API_KEY],
    }
  },
];

export default docRoutes;
